import { BnModalMixin } from '../../common/bn-modal-mixin';
import { html, LitEntity } from '../../utility/lit-entity';
import '../../common/bn-loading';
import './location-assign';

class LocationAssignModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'location-assign-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#${this.id} {
          --modal-min-width: 80%;
          --modal-max-width: 80%;
          --modal-body-overflow-y: visible;
        }
      </style>
      <h3 slot="title">Assign Work Order Location</h3>
      ${this._renderBody()}
    `;
  }

  _renderBody() {
    const selectInstallerAction = this.entity && this.entity.getActionByName('select-installer');
    if (!selectInstallerAction) {
      return html`<bn-loading></bn-loading>`;
    }
    return html`
      <location-assign
        .href="${selectInstallerAction.href}"
        @response="${this._onResponse}"
      ></location-assign>
    `;
  }

  _onResponse(e) {
    this.dispatchEvent(new CustomEvent('response'), { detail: e.detail, bubbles: true, composed: true });
    this.close();
  }
}

window.customElements.define('location-assign-modal', LocationAssignModal);
